/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_NotesInputs */



/**
* | output |
* | --- |
* | "Include Notes" |
*
* @param {Transcript_Export_Include_NotesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_notes = /** @type {((inputs?: Transcript_Export_Include_NotesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_NotesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Include Notes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Include Notes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Include Notes")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Include Notes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Include Notes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Include Notes")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Include Notes")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Include Notes")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Include Notes")
	return /** @type {LocalizedString} */ ("Include Notes")
});